import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'initials',
    pure: true,
    standalone: true
})
export class InitialsPipe implements PipeTransform {

    transform(value: string): string {
        if (value) {
            return value.replace('Dr. ','').split(' ').map((part) => part.substring(0, 1)).join('').substring(0, 3);
        }
        return '';
    }

}
